import {
  ComponentCommonAuthorDetailed,
  InsightEntity,
  PodcastEntity,
  ResourceEntity,
} from '@/graphql/generated/graphql';

export function getAuthors(resource?: ResourceEntity | PodcastEntity | InsightEntity) {
  const authors = resource?.attributes?.DefaultContentTemplate?.filter(
    (component) => component?.__typename === 'ComponentCommonAuthorDetailed',
  ).map((component: unknown) => {
    return (component as ComponentCommonAuthorDetailed)?.authors?.data
      .map((author) => author.attributes?.name)
      .join(', ');
  });

  return authors?.flatMap((author) => author).join(' ') || '';
}
